(() => {
  if (window.__caleoPreBlackCampaignLoaded) return;
  window.__caleoPreBlackCampaignLoaded = true;

  const config = window.CALEO_PREBLACK_CONFIG || {};
  const root = document.documentElement;
  let lastState = null;
  let boundaryTimer = null;
  let safetyTimer = null;

  const toTime = (value) => {
    if (!value) return NaN;
    const parsed = new Date(value).getTime();
    return Number.isFinite(parsed) ? parsed : NaN;
  };

  const formatThreshold = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL',
        maximumFractionDigits: Number.isInteger(value) ? 0 : 2
      }).format(value);
    } catch (error) {
      return `R$ ${value.toFixed(Number.isInteger(value) ? 0 : 2).replace('.', ',')}`;
    }
  };

  const isActiveNow = () => {
    if (!config.enabled) return false;
    if (config.forceActive) return true;

    const start = toTime(config.startAt);
    const end = toTime(config.endAt);
    const now = Date.now();

    if (!Number.isFinite(start) || !Number.isFinite(end)) return false;
    return now >= start && now <= end;
  };

  const syncStandardAnnouncement = (active) => {
    document.querySelectorAll('announcement-bar').forEach((bar) => {
      if (active) {
        if (bar.dataset.preBlackSuspended === 'true') return;
        if (typeof bar.unload === 'function') bar.unload();
        bar.dataset.preBlackSuspended = 'true';
        return;
      }

      if (bar.dataset.preBlackSuspended !== 'true') return;
      delete bar.dataset.preBlackSuspended;

      if (window.theme && theme.config && theme.config.mqlSmall && typeof bar.initOnMobile === 'function') {
        bar.initOnMobile();
      } else if (typeof bar.initOnDesktop === 'function') {
        bar.initOnDesktop();
      }
    });

    if (!active) {
      window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }
  };

  const setComponentState = (active) => {
    const thresholdCents = active
      ? Number(config.preBlackThresholdCents || 59900)
      : Number(config.standardThresholdCents || 0);
    const standardIsFree = thresholdCents <= 0;

    document.querySelectorAll('caleo-product-shipping-goal, caleo-cart-shipping-goal').forEach((element) => {
      element.dataset.thresholdCents = String(thresholdCents);
      element.dataset.thresholdLabel = formatThreshold(thresholdCents);
      element.dataset.campaignFreeShipping = active ? 'false' : String(standardIsFree || config.standardCampaignFreeShipping === true);
    });

    document.querySelectorAll('[data-caleo-free-shipping-cta]').forEach((element) => {
      element.dataset.thresholdCents = String(thresholdCents);
    });
  };

  const applyState = (active, force = false) => {
    if (!force && active === lastState) return;
    lastState = active;

    const thresholdCents = active
      ? Number(config.preBlackThresholdCents || 59900)
      : Number(config.standardThresholdCents || 0);

    root.classList.toggle('caleo-preblack-active', active);
    syncStandardAnnouncement(active);
    window.CALEO_PREBLACK_ACTIVE = active;
    window.CALEO_FREE_SHIPPING_THRESHOLD_CENTS = thresholdCents;
    window.CALEO_FREE_SHIPPING_THRESHOLD_LABEL = formatThreshold(thresholdCents);
    window.CALEO_FREE_SHIPPING_CAMPAIGN_ACTIVE = active ? false : config.standardCampaignFreeShipping === true;

    setComponentState(active);

    document.dispatchEvent(new CustomEvent('caleo:preblack-change', {
      detail: {
        active,
        thresholdCents
      }
    }));

    if (typeof window.__caleoFreeShippingRefresh === 'function') {
      window.__caleoFreeShippingRefresh();
    }

    if (window.miniCartShippingQuote && typeof window.miniCartShippingQuote.sync === 'function') {
      window.requestAnimationFrame(() => window.miniCartShippingQuote.sync());
    }
  };

  const tick = () => applyState(isActiveNow());

  const scheduleBoundary = () => {
    if (boundaryTimer) window.clearTimeout(boundaryTimer);
    boundaryTimer = null;

    if (!config.enabled || config.forceActive) return;

    const start = toTime(config.startAt);
    const end = toTime(config.endAt);
    const now = Date.now();
    let target = NaN;

    if (Number.isFinite(start) && now < start) {
      target = start;
    } else if (Number.isFinite(end) && now <= end) {
      target = end + 1;
    }

    if (!Number.isFinite(target)) return;

    const maxDelay = 2147483000;
    const delay = Math.max(0, Math.min(target - now + 25, maxDelay));
    boundaryTimer = window.setTimeout(() => {
      applyState(isActiveNow(), true);
      scheduleBoundary();
    }, delay);
  };

  applyState(isActiveNow(), true);
  scheduleBoundary();

  document.addEventListener('DOMContentLoaded', () => {
    applyState(isActiveNow(), true);
    scheduleBoundary();
  });
  document.addEventListener('shopify:section:load', () => applyState(isActiveNow(), true));

  if (!config.forceActive && config.enabled) {
    safetyTimer = window.setInterval(tick, 60000);
  }

  window.CaleoPreBlack = {
    refresh: () => applyState(isActiveNow(), true),
    isActive: isActiveNow
  };
})();
